<div class="report-settings">
  <div (click)="isToggle = !isToggle" class="head">
    Report settings
    <i class="fa"
       [class.fa-caret-down]="isToggle"
       [class.fa-caret-up]="!isToggle"></i>
  </div>
  <div [collapse]="isToggle">
    <form [formGroup]="formGroup">
    <div>
      <span>
        <input [checked]="getIsSet(reportSetting.RespondentsAnonymity)" (click)="toggleSetting(reportSetting.RespondentsAnonymity)" id="show-list-respondents" type="checkbox">
        <label for="show-list-respondents">Anonymity of respondents</label>
      </span>
    </div>
    <div>
      <span>
        <input [checked]="getIsSet(reportSetting.ResponsesAnonymity)" (click)="toggleSetting(reportSetting.ResponsesAnonymity)" id="show-responses" type="checkbox">
        <label for="show-responses">Anonymity of responses</label>
      </span>
    </div>
    <div>
      <span>
        <input [checked]="getIsSet(reportSetting.CompareComparisonGroup)" (click)="toggleSetting(reportSetting.CompareComparisonGroup)" id="compare-comparison-group" type="checkbox">
        <label for="compare-comparison-group">Comparison group</label>
      </span>
    </div>
    <div>
      <span>
        <input [checked]="getIsSet(reportSetting.ShowRespondentsGradeChart)" (click)="toggleSetting(reportSetting.ShowRespondentsGradeChart)" id="respondents-grade" type="checkbox">
        <label for="respondents-grade">Show respondents grade distribution chart</label>
      </span>
    </div>
    <div>
      <span>
        <input [disabled]="getIsCategoryChartDisabled()" [checked]="getIsSet(reportSetting.ShowRespondentsCategoryChart)" (click)="toggleSetting(reportSetting.ShowRespondentsCategoryChart)" id="respondents-category" type="checkbox">
        <label for="respondents-category">Show respondents category distribution chart</label>
      </span>
    </div>
    <br/>
    <div class="en-translation">
      <textarea maxlength="500" *ngFor="let item of descriptions; let i=index;" 
            [placeholder]="descriptionPlaceholders[i]" 
            [formControlName]="item"></textarea>  
    </div>
  </form>
  </div>
</div>



